import { combineReducers } from "redux";
import auth from "./auth";
import messages from "./messages";
import company from "./company";
import contract from "./contract";
import core from "./core";
import projects from "./projects";
import users from "./users";
import invoices from "./invoices";
import people from "./people";
import dashboard from "./dashboard";
import approvalWorkflow from "./approvalWorkflow";
import quote from "./quote";

export default combineReducers({
	auth,
	messages,
	company,
	core,
	contract,
	projects,
	users,
	invoices,
	people,
    dashboard,
    approvalWorkflow,
    quote
});